import { CONTACT } from '../../constants';
import './socialproof.css';

function SocialProof() {
  return (
    <section className="section socialproof">
      <div className="container">
        <div className="socialproof__header">
          <span className="section-label">Lo que dicen</span>
          <h2 className="section-title">Clientes que ya confían en EcoClean</h2>
          <p className="section-subtitle">
            Esto es lo que comparten quienes ya probaron nuestros productos y la forma de limpiar más consciente.
          </p>
        </div>

        <div className="socialproof__empty">
          {/* 
            ⚠️ PENDIENTE: Agregar testimonios reales acá.
            Pedir a la dueña: capturas de WhatsApp, reseñas de Google/Instagram, 
            fotos de productos en uso o antes/después.
            Formato sugerido:
            {
              text: '...',
              author: 'Nombre',
              source: 'Instagram / WhatsApp',
            }
          */}
          <div className="socialproof__placeholder">
            <p className="socialproof__placeholder-text">
              ¿Usaste nuestros productos? 
              <br />
              <a href={CONTACT.instagram} target="_blank" rel="noreferrer">Escribinos en Instagram</a> y compartí tu experiencia.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default SocialProof;
